// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.form-control{
    width: 100%;
    height: 70px;
    border-radius: 15px;
    border: 1px solid #215D88;
    margin-bottom: 24px;
    position: relative;
 }
 h2{
    font-size: 32px;
    color: #3AA1D5;
    font-weight: 600;
 }
 h3{
   font-size: 24px;
   color: black;
   font-weight: 300;
   margin-top: 16px;
}
.stu{
   position: absolute;
   top: 0;
   right: 0;
   width: 42%;
   /* z-index: 7777; */
   }
.bg-2{
   background-color: #F2F2F2;
   margin-bottom: 80px;
}

.btn-waitlist{
   padding: 12px 48px;
   background: #3AA1D5;
   border: none;
   border-radius: 62px;
   color: white;
   font-weight: 600;
   font-size: 24px;
   margin-top: 36px;
}

h2{
   color: #3AA1D5;
   margin: 0;
   font-weight: 600;
}
.stu-mob{
   position: relative;
   top: 110px;
   text-align: center;
}
.card{
   background: url(/assets/images/Aus/Subtraction.svg);
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
   border: none;
   padding: 48px;
   position: relative;
}
h4{
   min-height: 60px;
}
.non{
   background: url(/assets/images/Aus/sub2.png) !important;
   padding: 48px !important;
}
.card-body{
   padding: 1rem !important;
   position: relative;
   bottom: 45px;
}
.card h3::after{
   position: absolute;
   content: '';
   height: 2px;
   width: 130px;
   top: 32px;
   background-color: black;
   left: 0;
}
.card h3 , .card h4{
   font-weight: 600;
   position: relative;
}
.card img{
   width: 40px;
   height: 40px;
   margin-bottom: 6px;
}
.middle{
   margin: 4px 48px;
}
h5{
   font-size: 18px;
}
.last{
   display: flex;
   align-content: space-between;
   margin: 4px 48px;
}
.btn-know{
   padding: 8px 24px;
   background: #3AA1D5;
   border: none;
   border-radius: 62px;
   color: white;
   font-weight: 600;
   font-size: 18px;
   position: absolute;
   bottom: 4px;
   left: 114px;

}
.btn-know2{
   padding: 8px 24px;
   background: #393939;
   border: none;
   border-radius: 62px;
   color: white;
   font-weight: 600;
   font-size: 18px;
   position: absolute;
   bottom: 6px;
   left: 106px;

}
.close{
   color: black;
   text-align: right;
   padding: 4px 8px;
}
 @media screen and (max-width:768px){
   .front{
      margin-top: 60px !important;
   }
   h1{
      font-size: 24px;
      text-align: left;
   }
   h2,.code{
     font-size: 20px;
   }
   .pearson{
      font-size: 18px;
   }
   .stu {
      position: absolute;
      top: 100px;
      right: 0;
      width: 42%;
  }
  .stu-mob {
   position: relative;
   top: 30px;
   text-align: center;
   }
   .card{
      padding: 16px 4px;
      background-size: cover !important;
      background: white !important;
      margin-bottom: 16px !important;
   }
   .middle,.last{
      margin: 4px;
   }
   h3{
      font-size: 18px;
   }
   h4{
      font-size: 18px;
   }
   h5{
      font-size: 16px;
   }
   .card h3::after{
      top: 24px;
   }
   .card-body{
      bottom: 30px;
   }
   .btn-know , .btn-know2{
      padding: 6px 32px;
      font-size: 14px;
      left: 60px;
   }
   .stu{
      top: 204px;
   }
   .btn-waitlist {
      padding: 6px 48px;
      font-size: 18px;
      margin-top: 36px;
      margin-bottom: 36px;}
 }
 .front{
   margin-top: 80px;
    /* background-color: #1b57d9; */
    /* background-image: url(/assets/images/wait.svg); */
}
.was-validated .form-control:valid {
   border-color: #28a745 !important;}`, "",{"version":3,"sources":["webpack://./src/app/australia-flow/australia-flow.component.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;CACrB;CACA;IACG,eAAe;IACf,cAAc;IACd,gBAAgB;CACnB;CACA;GACE,eAAe;GACf,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;AACnB;AACA;GACG,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,UAAU;GACV,mBAAmB;GACnB;AACH;GACG,yBAAyB;GACzB,mBAAmB;AACtB;;AAEA;GACG,kBAAkB;GAClB,mBAAmB;GACnB,YAAY;GACZ,mBAAmB;GACnB,YAAY;GACZ,gBAAgB;GAChB,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,SAAS;GACT,gBAAgB;AACnB;AACA;GACG,kBAAkB;GAClB,UAAU;GACV,kBAAkB;AACrB;AACA;GACG,mDAAmD;GACnD,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;GACtB,YAAY;GACZ,aAAa;GACb,kBAAkB;AACrB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,uDAAuD;GACvD,wBAAwB;AAC3B;AACA;GACG,wBAAwB;GACxB,kBAAkB;GAClB,YAAY;AACf;AACA;GACG,kBAAkB;GAClB,WAAW;GACX,WAAW;GACX,YAAY;GACZ,SAAS;GACT,uBAAuB;GACvB,OAAO;AACV;AACA;GACG,gBAAgB;GAChB,kBAAkB;AACrB;AACA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,eAAe;AAClB;AACA;GACG,aAAa;GACb,4BAA4B;GAC5B,gBAAgB;AACnB;AACA;GACG,iBAAiB;GACjB,mBAAmB;GACnB,YAAY;GACZ,mBAAmB;GACnB,YAAY;GACZ,gBAAgB;GAChB,eAAe;GACf,kBAAkB;GAClB,WAAW;GACX,WAAW;;AAEd;AACA;GACG,iBAAiB;GACjB,mBAAmB;GACnB,YAAY;GACZ,mBAAmB;GACnB,YAAY;GACZ,gBAAgB;GAChB,eAAe;GACf,kBAAkB;GAClB,WAAW;GACX,WAAW;;AAEd;AACA;GACG,YAAY;GACZ,iBAAiB;GACjB,gBAAgB;AACnB;CACC;GACE;MACG,2BAA2B;GAC9B;GACA;MACG,eAAe;MACf,gBAAgB;GACnB;GACA;KACE,eAAe;GACjB;GACA;MACG,eAAe;GAClB;GACA;MACG,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,UAAU;EACd;EACA;GACC,kBAAkB;GAClB,SAAS;GACT,kBAAkB;GAClB;GACA;MACG,iBAAiB;MACjB,iCAAiC;MACjC,4BAA4B;MAC5B,8BAA8B;GACjC;GACA;MACG,WAAW;GACd;GACA;MACG,eAAe;GAClB;GACA;MACG,eAAe;GAClB;GACA;MACG,eAAe;GAClB;GACA;MACG,SAAS;GACZ;GACA;MACG,YAAY;GACf;GACA;MACG,iBAAiB;MACjB,eAAe;MACf,UAAU;GACb;GACA;MACG,UAAU;GACb;GACA;MACG,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,mBAAmB,CAAC;CACzB;CACA;GACE,gBAAgB;IACf,+BAA+B;IAC/B,oDAAoD;AACxD;AACA;GACG,gCAAgC,CAAC","sourcesContent":["\n.form-control{\n    width: 100%;\n    height: 70px;\n    border-radius: 15px;\n    border: 1px solid #215D88;\n    margin-bottom: 24px;\n    position: relative;\n }\n h2{\n    font-size: 32px;\n    color: #3AA1D5;\n    font-weight: 600;\n }\n h3{\n   font-size: 24px;\n   color: black;\n   font-weight: 300;\n   margin-top: 16px;\n}\n.stu{\n   position: absolute;\n   top: 0;\n   right: 0;\n   width: 42%;\n   /* z-index: 7777; */\n   }\n.bg-2{\n   background-color: #F2F2F2;\n   margin-bottom: 80px;\n}\n\n.btn-waitlist{\n   padding: 12px 48px;\n   background: #3AA1D5;\n   border: none;\n   border-radius: 62px;\n   color: white;\n   font-weight: 600;\n   font-size: 24px;\n   margin-top: 36px;\n}\n\nh2{\n   color: #3AA1D5;\n   margin: 0;\n   font-weight: 600;\n}\n.stu-mob{\n   position: relative;\n   top: 110px;\n   text-align: center;\n}\n.card{\n   background: url(/assets/images/Aus/Subtraction.svg);\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n   border: none;\n   padding: 48px;\n   position: relative;\n}\nh4{\n   min-height: 60px;\n}\n.non{\n   background: url(/assets/images/Aus/sub2.png) !important;\n   padding: 48px !important;\n}\n.card-body{\n   padding: 1rem !important;\n   position: relative;\n   bottom: 45px;\n}\n.card h3::after{\n   position: absolute;\n   content: '';\n   height: 2px;\n   width: 130px;\n   top: 32px;\n   background-color: black;\n   left: 0;\n}\n.card h3 , .card h4{\n   font-weight: 600;\n   position: relative;\n}\n.card img{\n   width: 40px;\n   height: 40px;\n   margin-bottom: 6px;\n}\n.middle{\n   margin: 4px 48px;\n}\nh5{\n   font-size: 18px;\n}\n.last{\n   display: flex;\n   align-content: space-between;\n   margin: 4px 48px;\n}\n.btn-know{\n   padding: 8px 24px;\n   background: #3AA1D5;\n   border: none;\n   border-radius: 62px;\n   color: white;\n   font-weight: 600;\n   font-size: 18px;\n   position: absolute;\n   bottom: 4px;\n   left: 114px;\n\n}\n.btn-know2{\n   padding: 8px 24px;\n   background: #393939;\n   border: none;\n   border-radius: 62px;\n   color: white;\n   font-weight: 600;\n   font-size: 18px;\n   position: absolute;\n   bottom: 6px;\n   left: 106px;\n\n}\n.close{\n   color: black;\n   text-align: right;\n   padding: 4px 8px;\n}\n @media screen and (max-width:768px){\n   .front{\n      margin-top: 60px !important;\n   }\n   h1{\n      font-size: 24px;\n      text-align: left;\n   }\n   h2,.code{\n     font-size: 20px;\n   }\n   .pearson{\n      font-size: 18px;\n   }\n   .stu {\n      position: absolute;\n      top: 100px;\n      right: 0;\n      width: 42%;\n  }\n  .stu-mob {\n   position: relative;\n   top: 30px;\n   text-align: center;\n   }\n   .card{\n      padding: 16px 4px;\n      background-size: cover !important;\n      background: white !important;\n      margin-bottom: 16px !important;\n   }\n   .middle,.last{\n      margin: 4px;\n   }\n   h3{\n      font-size: 18px;\n   }\n   h4{\n      font-size: 18px;\n   }\n   h5{\n      font-size: 16px;\n   }\n   .card h3::after{\n      top: 24px;\n   }\n   .card-body{\n      bottom: 30px;\n   }\n   .btn-know , .btn-know2{\n      padding: 6px 32px;\n      font-size: 14px;\n      left: 60px;\n   }\n   .stu{\n      top: 204px;\n   }\n   .btn-waitlist {\n      padding: 6px 48px;\n      font-size: 18px;\n      margin-top: 36px;\n      margin-bottom: 36px;}\n }\n .front{\n   margin-top: 80px;\n    /* background-color: #1b57d9; */\n    /* background-image: url(/assets/images/wait.svg); */\n}\n.was-validated .form-control:valid {\n   border-color: #28a745 !important;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
